import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { CollectionState, FiltersMap } from '@wix/bex-core';
import { InfiniteScrollTableV2 } from '../..';
import { InfiniteScrollTableState } from '../../state';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { CollectionTableBaseProps } from '../CollectionTable';

export interface InfiniteScrollTableCompatProps<T, F extends FiltersMap>
  extends CollectionTableBaseProps<T, F> {
  /**
   * A collection state instance created with [useInfiniteScrollTable](/pages/cairo/?path=/story/components-collection-hooks--useinfinitescrolltable)
   * @external
   */
  state: CollectionState<T, F> | InfiniteScrollTableState<T, F>;
}

function _InfiniteScrollTableCompat<T, F extends FiltersMap = FiltersMap>(
  props: InfiniteScrollTableCompatProps<T, F>,
) {
  const container = useWixPatternsContainer();

  const [state] = useState(() =>
    props.state instanceof InfiniteScrollTableState
      ? props.state
      : new InfiniteScrollTableState<T, F>({
          collection: props.state,
          container,
        }),
  );

  return <InfiniteScrollTableV2 {...props} state={state} />;
}

export const InfiniteScrollTableCompat = observer(_InfiniteScrollTableCompat);
